const key = "recentrouterpaths";
function addToRecents({ name }) {
  const path = window.location.pathname;
  try {
    let recents = getRecents();
    if (recents.length >= 8) {
      recents.splice(8, recents.length);
    }
    recents.reverse();
    recents = recents.filter(obj => {
      if (obj.path === path) {
        return false;
      }
      return true;
    });
    recents.push({ name, path });
    recents.reverse();
    localStorage.setItem(key, JSON.stringify(recents));
  } catch (err) {
    console.error(err);
    return null;
  }
}
function clearPath({ path }) {
  try {
    let recents = getRecents();

    recents = recents.filter(obj => {
      if (obj.path === path) {
        return false;
      }
      return true;
    });
    recents.push({ name, path });
    recents.reverse();
    localStorage.setItem(key, JSON.stringify(recents));
  } catch (err) {
    console.error(err);
  }
}
/**
 * @returns {Array}
 */
function getRecents() {
  try {
    return localStorage.getItem(key)
      ? JSON.parse(localStorage.getItem(key))
      : [];
  } catch (err) {
    console.error(err);

    return null;
  }
}
export default Object.freeze({
  addToRecents,
  getRecents,
  clearPath
});
